import { Pipe, PipeTransform } from '@angular/core';
import { FileInfo, FileState } from '@progress/kendo-angular-upload';
// @ts-ignore
import { LocalizationService } from '@progress/kendo-angular-l10n';
import * as _ from 'lodash';
// @ts-ignore
import { StringUtils } from '@technocom/common/util';

@Pipe({
  name: 'fileStatusText',
})
export class FileStatusTextPipe implements PipeTransform {
  constructor() {}

  transform(file: FileInfo, localization: LocalizationService): string {
    return this.getFileStatusText(file, localization);
  }

  private getFileStatusText(file: FileInfo, localization: LocalizationService): string {
    if (this.isUploadFailed(file)) {
      return `Ошибка при загрузке файла`;
    }

    if (this.hasValidationErrors(file)) {
      return this.getFileValidationMessage(file, localization);
    }

    return StringUtils.filesize(file.size);
  }

  private isUploadFailed(file: FileInfo): boolean {
    return file.state === FileState.Failed;
  }

  private hasValidationErrors(file: FileInfo) {
    return _.isNil(file.validationErrors) === false;
  }

  private getFileValidationMessage(file: FileInfo, localization: LocalizationService): string {
    let validationMessage: string;

    if (file.validationErrors && file.validationErrors.length > 0) {
      validationMessage = localization.get(file.validationErrors[0]);
    }

    return validationMessage;
  }
}
/* eslint-disable  no-bitwise */

const getTotalFilesSizeMessage1 = files => {
  let totalSize = 0;
  let i;
  if (typeof files[0].size === 'number') {
    for (i = 0; i < files.length; i++) {
      if (files[i].size) {
        totalSize += files[i].size;
      }
    }
  } else {
    return '';
  }
  totalSize /= 1024;
  if (totalSize < 1024) {
    return totalSize.toFixed(2) + ' KB';
  } else {
    return (totalSize / 1024).toFixed(2) + ' MB';
  }
};
